import { gemmiciApiServiceClient } from "../../core/apis/gemmiciApiService/AxiosIntance";

export default {
  retrieveUserProfileAPI() {
    return gemmiciApiServiceClient.get("profile/me");
  },
  retrieveUserCreatorProfileAPI() {
    return gemmiciApiServiceClient.get("share/creator/profile/me");
  },
  retrieveProfileAPI(username) {
    return gemmiciApiServiceClient.get("profile/show/" + username);
  },
  editUserAPI(data) {
    return gemmiciApiServiceClient.put("/users", {
      username: data.username,
      email: data.email
    });
  },
  editProfileAPI(data) {
    return gemmiciApiServiceClient.put("profile/edit", {
      description: data.description
    });
  },
  createCreatorProfileAPI(data) {
    return gemmiciApiServiceClient.post("share/creator/create/profile", {
      username: data.username,
      websites: data.websites
    });
  }
};
